module.exports = "/_next/static/images/90668f4081b976af5676649c3dbfe389-sanpablo-1.jpg";